import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavAutomationComponent } from '@app/features/nav-automation/pages/nav-automation.component';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';

@NgModule({
    declarations: [
        NavAutomationComponent
    ],
    imports: [
        CommonModule,
        CoreModule,
        SharedModule
    ],
    providers: []
})
export class NavAutomationModule {
}
